<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7178 6.79422C18.4697 6.77188 18.3015 6.96708 18.2956 7.19403L17.9182 20.7382C17.9111 20.9758 17.7042 21.1769 17.4666 21.1769L6.52589 21.1769C6.28835 21.1769 6.08139 20.9758 6.07551 20.7382L5.69334 7.19404C5.68746 6.96708 5.52753 6.81186 5.27001 6.79423C5.04306 6.80128 4.86314 6.9906 4.8702 7.21755L5.2512 20.7618C5.27119 21.445 5.84268 22 6.52471 22L17.4654 22C18.1486 22 18.7201 21.445 18.739 20.7618L19.1164 7.21755C19.1235 6.9906 18.9447 6.80128 18.7178 6.79422Z"
      :fill="iconColor"
    />
    <path
      d="M9.18464 7.20568L9.18465 18.9049C9.18465 19.1318 9.36927 19.3164 9.59622 19.3164C9.82317 19.3164 10.0078 19.133 10.0078 18.9049L10.0078 7.20568C10.0078 6.97872 9.82317 6.7941 9.59622 6.7941C9.36926 6.7941 9.18464 6.97872 9.18464 7.20568Z"
      :fill="iconColor"
    />
    <path
      d="M13.9788 7.20567L13.9788 18.9049C13.9788 19.1318 14.1623 19.3164 14.3904 19.3164C14.6185 19.3164 14.802 19.133 14.802 18.9049L14.802 7.20567C14.802 6.97872 14.6185 6.7941 14.3904 6.7941C14.1623 6.7941 13.9788 6.97872 13.9788 7.20567Z"
      :fill="iconColor"
    />
    <path
      d="M5.28172 4.74106L18.706 4.74106C18.9329 4.74106 19.1176 4.55644 19.1176 4.32949C19.1176 4.10254 18.9341 3.91792 18.706 3.91792L14.8019 3.91792L14.8019 2.41157C14.8019 2.18462 14.6185 2 14.3904 2L9.59616 2C9.3692 2 9.18459 2.18462 9.18459 2.41157L9.18459 3.91792L5.28172 3.91792C5.05477 3.91792 4.87015 4.10254 4.87015 4.32949C4.87015 4.55644 5.05477 4.74106 5.28172 4.74106ZM10.0077 2.82314L13.9788 2.82314L13.9788 3.91792L10.0077 3.91792L10.0077 2.82314Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "iconDelete",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
